import { render } from "./icon-diamond.vue?vue&type=template&id=a8e91318"
const script = {}

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__